import { inactiveClosesOnLabel } from '@/utils';
import styles from './StatusBadge.module.css';

type Status = 'pending_payment' | 'payment_requested' | 'active' | 'closure_requested' | 'resolution_rejected' | 'closed';

// eslint-disable-next-line react-refresh/only-export-components
export function statusLabel(status: Status): string {
  if (status === 'active')               return 'Actief';
  if (status === 'pending_payment')      return 'Betaling vereist';
  if (status === 'payment_requested')    return 'Betaling gevraagd';
  if (status === 'closure_requested')    return 'Afronden gevraagd';
  if (status === 'resolution_rejected')  return 'Actief';
  return 'Gesloten';
}

interface Props {
  status: Status;
  label: string;
  /** Use the compact (smaller) size, e.g. in list cards. Default: false */
  compact?: boolean;
  /** conversations.flagged_inactive_at — shows a "Verloopt DD/MM" overlay instead of the normal status, unless closed. */
  flaggedInactiveAt?: string | null;
}

export function StatusBadge({ status, label, compact = false, flaggedInactiveAt = null }: Props) {
  const isFlaggedInactive = flaggedInactiveAt != null && status !== 'closed';

  const statusClass =
    isFlaggedInactive                ? styles.inactive :
    status === 'active'              ? styles.active  :
    status === 'pending_payment'     ? styles.pending :
    status === 'payment_requested'   ? styles.pending :
    status === 'closure_requested'   ? styles.pending :
    status === 'resolution_rejected' ? styles.active  :
    styles.closed;

  const className = `${styles.badge}${compact ? ` ${styles.badgeCompact}` : ''} ${statusClass}`;

  return <span className={className}>{isFlaggedInactive ? `Verloopt ${inactiveClosesOnLabel(flaggedInactiveAt!)}` : label}</span>;
}
